import { Video } from '@/types'
import { globalState } from '@codeleap/store'

/**
 * A feed item's video URI, when something already knows a better one than `video.url` — a
 * just-recorded local file while Bunny is still transcoding (`community/post.ts`,
 * `community/prompt.ts`). In-memory only (no `persistKey`), so it's gone on the next load —
 * there's nothing to reconcile a stale override against once the tab is closed.
 */
class VideoCache {
  private readonly overrides = globalState<Record<string, string>>({})

  get(id: string | number): string | undefined {
    return this.overrides.get()[String(id)]
  }

  set(id: string | number, uri: string) {
    this.overrides.set({ [String(id)]: uri })
  }

  /** The URI a feed item should actually play: the override if one was ever `set`, else the
   * video's own URL. */
  use(id: string | number, video?: Pick<Video, 'url'>): string {
    const override = this.overrides.use(s => s[String(id)])
    return override ?? video?.url
  }
}

export const videoCache = new VideoCache()
